import React from "react";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";

import * as Grid from "@ui/Atoms/Grid";
import { Text } from "@ui/Atoms/Text";

import { PrismicLandingPageV2DataBodyTimeline } from "@www/graphql-types";

import * as Styled from "./Timeline.styled";

export const Timeline = (
  props: SliceComponentProps<PrismicLandingPageV2DataBodyTimeline>,
) => {
  const { primary, items } = props.slice;

  return (
    <Styled.Root>
      <Grid.Row>
        <Styled.Container md={10} pushMd={1} lg={8} pushLg={2}>
          <Text as="h2" $style="bold_32">
            {primary.timeline_title.text}
          </Text>

          <Styled.TimelineList>
            {items.map((item, index) => (
              <Styled.TimelineItem key={index}>
                <Styled.TimelineIcon />

                <Styled.Event>
                  <Text
                    as="h3"
                    $style={{
                      default: "semibold_20",
                      largeMobile: "semibold_24",
                    }}
                  >
                    {item.event_title.text}
                  </Text>

                  <PrismicRichText
                    field={item.event_description.richText}
                    components={{
                      paragraph: props => (
                        <Text
                          key={props.key}
                          as="p"
                          $style={{
                            default: "regular_16",
                            largeMobile: "regular_18",
                          }}
                        >
                          {props.children}
                        </Text>
                      ),
                      strong: props => (
                        <Text
                          key={props.key}
                          as="strong"
                          $style={{
                            default: "bold_16",
                            largeMobile: "bold_18",
                          }}
                        >
                          {props.children}
                        </Text>
                      ),
                    }}
                  />
                </Styled.Event>
              </Styled.TimelineItem>
            ))}
          </Styled.TimelineList>
        </Styled.Container>
      </Grid.Row>
    </Styled.Root>
  );
};
